
/* 


        //TODO  此处添加语言
        languageList.add(new LanguageBean(ENGLISH, "English"));
        languageList.add(new LanguageBean(JAPANESE, "日本語"));
        languageList.add(new LanguageBean(KOREAN, "한국어"));
        languageList.add(new LanguageBean(FRENCH, "Français"));
        languageList.add(new LanguageBean(ITALY, "Italiano"));
        languageList.add(new LanguageBean(RUSSIAN, "Русский язык"));
        languageList.add(new LanguageBean(SPANISH, "Español"));
        languageList.add(new LanguageBean(GERMANY, "Deutsch"));
        languageList.add(new LanguageBean(PORTUGUESE, "Português"));
        languageList.add(new LanguageBean(HINDI, "हिन्दी"));
        languageList.add(new LanguageBean(VIETNAM, "Tiếng việt nam"));
        languageList.add(new LanguageBean(THAILAND, "ไทย"));
        languageList.add(new LanguageBean(INDONESIA, "Orang indonesia"));
        languageList.add(new LanguageBean(SIMPLE_CHINESE, "中文(简体)"));
        languageList.add(new LanguageBean(TRADITIONAL_CHINESE_HK, "中文(繁體)"));
        languageList.add(new LanguageBean(ARABIC, " عربي ، "));
        languageList.add(new LanguageBean(TURKISH, "Turkish"));


*/
// 语言列表
export const userLangArr = [
    {
        key: "en",
        name: "English",
    },
    {
        key: "ar",
        name: " عربي ، ",
    },
    {
        key: "de",
        name: "Deutsch",
    },
    {
        key: "es",
        name: "Español",
    },
    {
        key: "fr",
        name: "Français",
    },
    {
        key: "hi",
        name: "हिन्दी",
    },
    {
        key: "id",
        name: "Orang indonesia",
    },
    {
        key: "it",
        name: "Italiano",
    },
    {
        key: "ja",
        name: "日本語",
    },
    {
        key: "ko",
        name: "한국어",
    },
    {
        key: "pt",
        name: "Português",
    },
    {
        key: "ru",
        name: "Русский язык",
    },
    {
        key: "th",
        name: "ไทย",
    },
    {
        key: "tr",
        name: "Turkish",
    },
    {
        key: "vi",
        name: "Tiếng việt nam",
    },
    {
        key: "zh",
        name: "中文(简体)",
    },
    {
        key: "zh-rHK",
        name: "中文(繁體)",
    },
]

// 数组转换为字符串
export const arrToString = (arr,s) => {
    let string='';
    let symbol=s||','//分割符耗
    arr.forEach((item,index) => {
        if(index>=arr.length-1){
            string+=item
        }else{            
            string+=item+symbol
        }
    });
    return string
}


// WEBPACK FOOTER //
// ./src/utils/common.js